import React from 'react';
import { Card } from '@nextui-org/react';
import { useDispatch, useSelector } from 'react-redux';
import { finalizeProcessingPayment } from '../../../store/processingPayment/slice';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PageLayout from '../../components/common/PageLayout';
import PurchaseSessionStepsHeader from '../../components/common/PurchaseSessionStepsHeader';
import { PurchaseSessionStep } from '../../../constants/purchaseSession';
import AdminDataFooter from '../../components/common/AdminDataFooter';
import Button from '../../components/common/Button';
import Typography from '../../components/common/Typography';
import theme from '../../theme';
import { StoreState } from '../../../store/reducer-main';

export default function PaymentSuccessPage() {

  const dispatch = useDispatch();

  const { product } = useSelector((state: StoreState) => state.purchaseSession);

  const onProceed = async () => {
    dispatch(finalizeProcessingPayment());
  }

  return (
    <PageLayout>
      <PurchaseSessionStepsHeader
        selectedStep={PurchaseSessionStep.CONFIRM} />
      <div className='flex flex-1 justify-center items-center'>
        <Card className='p-16 gap-8' style={{maxWidth: '500px'}}>
          <CheckCircleIcon 
            style={{
              fontSize: theme.sizing.x12,
              color: theme.color.success, 
              marginLeft: 'auto', 
              marginRight: 'auto'
            }}/>
          <Typography 
            variant='headline3'
            className='text-center' 
            style={{fontWeight: 300}}>
              {`L'acquisto del piano ${product?.name ?? ''} è andato a buon fine`}
          </Typography>
          <Button 
            title='PROSEGUI'
            onClick={onProceed}/>
        </Card>
      </div>
      <AdminDataFooter colorVariant='text' />
    </PageLayout>
  )
}